import { coreActions } from '@sonar-software/sonar-core';
import { isEqual } from 'lodash';
import { SonarText } from '@ui/text';
import { Space } from 'antd';
import { UserSelector } from '@ui/UserSelector';

import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';
import { useAction, useTagReference } from '@hooks';

export interface TagOwnersSectionProps {
	tagId?: number;
}

export const TagOwnersSection: React.FC<TagOwnersSectionProps> = ({ tagId }) => {
	const tag = useTagReference(tagId);

	const requestPut = useAction(coreActions.requestPutCoreTagsById);

	const handleChange = useCallback((owners: number[]) => {
		if (tagId && !isEqual(tag.ownerIds, owners)) {
			requestPut({
				...tag,
				ownerIds: owners ?? []
			});
		}
	}, [ requestPut, tag, tagId ]);

	return (
		<Space
			className='tag-owner-section'
			direction='vertical'
			size={ 4 }>
			<SonarText
				size={ 16 }
				weight='semibold'>
				{ COPY_SPECIFIC.OWNERS }
			</SonarText>
			<UserSelector
				direction='horizontal'
				disabled={ tag.autoTagged }
				mode='multiple'
				onMultipleChange={ handleChange }
				placeholder={ PLACEHOLDERS_COPY.ADD_OWNER }
				showSearch={ false }
				value={ tag.ownerIds } />
		</Space>
	);
};
